// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app\\components\\pages\\studios\\StudiosSection\\index.ts"
);
import.meta.hot.lastModified = "1757171103347.9978";
}
// REMIX HMR END

export { StudiosSection } from "./StudiosSection";
